module.exports = __webpack_public_path__ + "img/ai-visuallize-app.84261025.png";